import * as React from 'react';
import '../SuperUser/css/SuperUserPageView.css'
import { Route } from 'react-router-dom';

import techSheetImage from './img/techSheets.png';

export interface IBatchDownloadsProps {
}

export interface IBatchDownloadsState {
}

export default class BatchDownloadsTable extends React.Component<IBatchDownloadsProps, IBatchDownloadsState> {
  tableRow: HTMLElement;
  constructor(props: IBatchDownloadsProps) {
    super(props);
    this.state = {
    };
  }

  render() {

    return (
      <div className="inner-su-container">
        <div className="manage-single-item-row">
          <div className="in-row-text-container">
            Batch Downloads
          </div>
        </div>

        <table className="table-scrollable images-table">
          <tbody className="images-table-body">
              <tr>
                <td className="imageMainTableCell">
                    <Route
                        render={({ history }) => {
                            return (
                                <button onClick={() => history.push('/BatchDownloadTechSheets')} title="Seed Dividers">
                                    <div><b>Seed Tech Sheets</b></div>
                                    <img className="imageMainTableImage" src={techSheetImage} />
                                </button>
                            );
                        }}
                    />
                </td>
              </tr>
          </tbody>
        </table>

      </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/BatchDownloads/BatchDownloads.tsx